import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.scss']
})
export class IdentificationComponent {
  @Input() code!: string;
  @Input() libelle!: string;
  @Input() proprietaire!: string;
  @Input() createur!: string;

  constructor() {}
}
